import ParametersManagement from '@src/main/modules/parameters/ui/parameters-management/components/ParametersManagement';

const ParametersManagementPage = () => <ParametersManagement />;

export default ParametersManagementPage;
